// Normalizes the "reimbursement" invoice type shared by ARSL/ATL/AE/ES —
// pure payroll cost passthrough (no service charge, no GST, no WHT), built by
// calculateSummary() in functions/builders/helpers.js:1 from per-employee
// rows: { employees, salary, allowance, total, eobi, pessi, grandTotal }.
import { LINE_CATEGORIES, makeLine } from "../lineCategories";

export function normalizeReimbursementInvoice(invoice) {
  const summary = invoice.summary || {};
  const salary = Number(summary.salary || 0);
  const allowance = Number(summary.allowance || 0);
  const eobi = Number(summary.eobi || 0);
  const pessi = Number(summary.pessi || 0);
  // Flat, non-payroll reimbursements (e.g. ARSL's BSPM Resource Cost invoice)
  // that don't fit the salary/allowance/EOBI/PESSI shape — optional, unset
  // for every ordinary headcount-based upload.
  const otherReimbursement = Number(summary.otherReimbursement || 0);
  const grandTotal = Number(summary.grandTotal || (salary + allowance + eobi + pessi + otherReimbursement));

  // Allowance and other flat reimbursements are folded into
  // SALARY_REIMBURSEMENT (as separate line entries, distinct descriptions
  // preserved) rather than their own categories — they're paid out with
  // salary, so Monthly P&L's category breakdown groups them together.
  const lines = [
    makeLine({ category: LINE_CATEGORIES.SALARY_REIMBURSEMENT, description: "Salary reimbursement", amount: salary, sourceField: "summary.salary" }),
    makeLine({ category: LINE_CATEGORIES.SALARY_REIMBURSEMENT, description: "Allowance recovery", amount: allowance, sourceField: "summary.allowance" }),
    makeLine({ category: LINE_CATEGORIES.EOBI_RECOVERY, description: "EOBI recovery", amount: eobi, sourceField: "summary.eobi" }),
    makeLine({ category: LINE_CATEGORIES.PESSI_RECOVERY, description: "PESSI recovery", amount: pessi, sourceField: "summary.pessi" })
  ];
  if (otherReimbursement) {
    lines.push(makeLine({
      category: LINE_CATEGORIES.SALARY_REIMBURSEMENT,
      description: summary.otherReimbursementDescription || "Other reimbursement",
      amount: otherReimbursement,
      sourceField: "summary.otherReimbursement"
    }));
  }

  return {
    lines,
    serviceChargeSubtotal: 0,
    invoiceAmount: grandTotal,
    gstAmount: 0,
    grossAmount: grandTotal,
    recoveryBase: null,
    recoveryAddBack: null
  };
}
